import { render, staticRenderFns } from "./contract-credits-nl.vue?vue&type=template&id=88cb4c5a&scoped=true"
import script from "./contract-credits-nl.vue?vue&type=script&lang=js"
export * from "./contract-credits-nl.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=88cb4c5a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cb4c5a",
  null
  
)

export default component.exports